import { render, staticRenderFns } from "./CollectiveDelivery.vue?vue&type=template&id=7f6226ba&scoped=true&"
import script from "./CollectiveDelivery.vue?vue&type=script&lang=js&"
export * from "./CollectiveDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CollectiveDelivery.vue?vue&type=style&index=0&id=7f6226ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6226ba",
  null
  
)

export default component.exports